import { firebase } from './init';

const db = firebase.firestore();

var loggedInUser = null

export const storeUser = (uid, username, email, handicapper) => {
	db.collection("users").doc(uid).set({
	    email: email,
	    username: username,
	    handicapper: handicapper,
	    profile_created: Date.now()
	})
}


export const getUser = (uid, callback) => {
	if (loggedInUser) callback(loggedInUser, null)
	else {
		db.collection("users").doc(uid)
			.get()
	  		.then(docSnapshot => {
	        	if (docSnapshot.exists) {
	        		loggedInUser = docSnapshot.data()
	        		callback(docSnapshot.data(), null)
	        	} else {
	        		callback(null, "User doesn't exits.")
	        	}
	      	})
	      	.catch(function(error) {
		        console.log("Error getting documents: ", error);
	      		callback(null, error)
		    });
	}
}

export const getGame = (gid, callback) => {
	db.collection("games").doc(gid)
		.get()
			.then(docSnapshot => {
	    	if (docSnapshot.exists) {
	    		var game =  docSnapshot.data()
	    		game.id = gid
	    		callback(game, null)
	    	} else {
	    		callback(null, "Game doesn't exits.")
	    	}
	  	})
	  	.catch(function(error) {
	        console.log("Error getting documents: ", error);
	  		callback(null, error)
	    });
	
}

export const getHandicappers = (callback) => {
	db.collection("users").where("handicapper", "==", true)
		.get()
	  	.then(querySnapshot => {
        	if (!querySnapshot.empty) {
        		var data = []
        		querySnapshot.forEach(function (docSnapshot) {
        			var item = docSnapshot.data()
        			item.id = docSnapshot.id
				  	data.push(item)
				});
	          	callback(data, null)
        	} else {
        		callback(null, "No handicappers.")

        	}
        })
      	.catch(function(error) {
	        console.log("Error getting documents: ", error);
      		callback(null, error)
	    });
}

export const getHandicapperPicks = (hid, callback) => {
	db.collection("picks").where("handicapper", "==", hid).orderBy('created').limit(10)
		.get()
  		.then(querySnapshot => {
        	if (!querySnapshot.empty) {
        		var data = []
        		querySnapshot.forEach(function (docSnapshot) {
        			var item = docSnapshot.data()
        			item.id = docSnapshot.id
				  	data.push(item)
				});
	          	callback(data, null)
        	} else {
        		callback(null, "No picks.")

        	}
        })
      	.catch(function(error) {
	        console.log("Error getting documents: ", error);
      		callback(null, error)
	    });
}


export const getAllPickGames = (gids, callback) => {

  	const gamePromises = gids.map(
		id => db.collection('games').doc(id).get()
	);

	Promise.all(gamePromises)
		.then(function (snapshot) {
			var games = []
			snapshot.forEach(doc => {
				console.log(doc)
				games[doc.id] = doc.data()
			})
			
			callback(games, null)
		})
		.catch(function(err) {
			console.log(err)
			callback(null, err)
		})

}

export const getAllHandicappers = (hids, callback) => {

  	const handiPromises = hids.map(
		id => db.collection('users').doc(id).get()
	);

	Promise.all(handiPromises)
		.then(function (snapshot) {
			var handis = []
			snapshot.forEach(doc => {
				console.log(doc)
				handis[doc.id] = doc.data()
			})
			
			callback(handis, null)
		})
		.catch(function(err) {
			console.log(err)
			callback(null, err)
		})

}

export const getUserPicks = (uid, callback) => {
	db.collection('users').doc(uid).collection('bought').get()
		.then(querySnapshot => {
        	if (!querySnapshot.empty) {
        		var pids = []
        		querySnapshot.forEach(function (docSnapshot) {
        			var item = docSnapshot.data()
        			item.id = docSnapshot.id
        			console.log(item.pick)
        			if (pids.includes(item.pick) === false) {
					  	pids.push(item.pick)
        			}
				});
        		console.log(pids)
				const pickPromises = pids.map(
					id => db.collection('picks').doc(id).get()
				);

				Promise.all(pickPromises)
					.then(function (snapshot) {
						var picks = []
						snapshot.forEach(doc => {
							// console.log(doc)
							picks.push(doc.data())
						})
						
						callback(picks, null)
					})
					.catch(function(err) {
						console.log(err)
						callback(null, err)
					})


        	} else {
        		callback(null, "No picks.")

        	}
        })
      	.catch(function(error) {
	        console.log("Error getting documents: ", error);
      		callback(null, error)
	    });
}

export const buyPickSet = (uid, pid, callback) => {
	console.log("TRY TO FAKE BUY")
	console.log(uid)
	console.log(pid)
	db.collection('users').doc(uid).collection('bought').add({"pick": pid, "bought": Date.now()})
		.then(function() {
	    	callback(true, null);
		})
		.catch(function(error) {
		    callback(null, error);
		});

}

export const getGames = (league, callback) => {
	console.log(Date.now())
	db.collection("games").where("league", "==", league).where("timestamp", ">", Date.now())
		.get()
  		.then(querySnapshot => {
        	if (!querySnapshot.empty) {
        		var data = []
        		querySnapshot.forEach(function (docSnapshot) {
        			var item = docSnapshot.data()
        			item.id = docSnapshot.id
				  	data.push(item)
				});
	          	callback(data, null)
        	} else {
        		callback(null, "No games for this league.")

        	}
        })
      	.catch(function(error) {
	        console.log("Error getting documents: ", error);
      		callback(null, error)
	    });
}


export const storePickSet = (uid, picks, callback) => {
	db.collection("picks").add({
	    handicapper: uid,
	    picks: picks,
	    created: Date.now(), 
	    completed: false
	}).then(function() {
    	callback(true, null);
	})
	.catch(function(error) {
	    callback(null, error);
	});

}





// WEBPACK FOOTER //
// ./src/firebase/db.js